import React, {Component} from "react";
import Button from "./Button";

/**
 * @class Button
 *
 * Displays a generic button
 *
 * @param {string} [className] - specific classes to be applied to the dropdown
 * @param {string} name - dropdown name
 * @param {DropdownToggleButton} toggleButton - data for toggle button
 * @param {string|React.ReactElement} content - dropdown name
 * @param {string} contentClassName - specific classes to be applied to content
 *
 */
export default class Dropdown extends Component {
    render() {
        return (
            <div className={"dropdown " + (this.props.className ?? "")}>
                <Button
                    className={this.props.toggleButton.className}
                    svgBefore={this.props.toggleButton.svgBefore}
                    svgAfter={this.props.toggleButton.svgAfter}
                    label={this.props.toggleButton.label}
                    elementProps={{
                        id: this.props.name,
                        "data-toggle": "dropdown"
                    }}
                />

                <div
                    className={"generic-dropdown-menu dropdown-menu " + (this.props.contentClassName ?? "")}
                    aria-labelledby={this.props.name}
                >
                    {this.props.content}
                </div>
            </div>
        );
    }
}
